import { render, staticRenderFns } from "./BirimSecimiFilter2.vue?vue&type=template&id=1228129e"
import script from "./BirimSecimiFilter2.vue?vue&type=script&lang=js"
export * from "./BirimSecimiFilter2.vue?vue&type=script&lang=js"
import style0 from "./BirimSecimiFilter2.vue?vue&type=style&index=0&id=1228129e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports